import React, { Component } from 'react';
import { Switch, BrowserRouter, Route } from 'react-router-dom';
import i18next from 'i18next'

import { TransitionGroup, CSSTransition } from "react-transition-group";

import {LangChangeEventContext} from './contexts/LangContext'

import Main     from './pages/Main';
import Gallery  from './pages/Gallery';
import Contacts from './pages/Contacts';

let canScrollX = true;
let canScrollY = true;
let scrollingsY = [];
let scrollingsX = [];
let prevTime = 0;
let isSafari = false;
let timeStamp = 0;
export default class AppRouter extends Component{

  constructor() {
    super();
    this.changeLang = this.changeLang.bind(this);
    this.changeLangEn = this.changeLangEn.bind(this);
    this.changeLangRu = this.changeLangRu.bind(this);
  }

  state = {
    lang: "ru",
    resize: 0,
    changeHistory: true,
    scrollY: {},
    scrollId: 0
    // lang:''
  };

  componentWillMount() { 
    this.initLangs();     
    window.addEventListener('resize', this.resizeMode);
    window.addEventListener('wheel', this.onWheel);
    isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  }
  resizeMode = () => {
    this.setState({resize:this.state.resize+1})
  }
  initLangs(){
    i18next.init({ 
      lng: 'ru', 
      resources: {
        'en': this.props.en,
        'ru': this.props.ru
        }
    })   
  }
  
  changeLang(){
    if (this.state.lang === "ru") {
      i18next.changeLanguage('en');
      this.setState({lang: "en"});
    } else {
      i18next.changeLanguage('ru');
      this.setState({lang: "ru"});
    }
  }
  changeLangRu(){          
    i18next.changeLanguage('ru');
    this.setState({lang: "ru"});
  }
  changeLangEn(){   
    i18next.changeLanguage('en');
    this.setState({lang: "en"});
  }
  onWheel = e =>{
    if(document.documentElement.clientWidth > 1025){e.preventDefault();}
    var curTime = new Date().getTime();
    if(scrollingsX.length > 149){
      scrollingsY.shift(); 
      scrollingsX.shift();}
    scrollingsY.push(Math.abs(e.deltaY));
    scrollingsX.push(Math.abs(e.deltaX));
    var timeDiff = curTime-prevTime;
    prevTime = curTime;
    if(timeDiff > 300){
      scrollingsY  = [];
      scrollingsX = [];
    }
    var averageEnd;
    var averageMiddle;
    var isAccelerating;
    var isMac;
    // console.log(this.getAverage(scrollingsY, 70) +' y - x '+ this.getAverage(scrollingsX, 70)/3);
    if( canScrollX && (this.getAverage(scrollingsY, 70) < this.getAverage(scrollingsX, 70)/3)){
      averageEnd     = this.getAverage(scrollingsX, 10);
      averageMiddle  = this.getAverage(scrollingsX, 70);
      isAccelerating = averageEnd >= averageMiddle;
      isMac = true;
      if(isSafari){
        isMac = 1.3<(Math.abs(e.deltaX)/(e.timeStamp-timeStamp));
      }
      if(isAccelerating && isMac){
        canScrollX = false;
        setTimeout(()=>{canScrollX = true}, 700);
        if(e.deltaX<0){
          window.history.back();
        }else{
          window.history.forward();
        }
      }    
      timeStamp = e.timeStamp;
    }else if(canScrollY && (document.documentElement.clientWidth > 1025)){
      averageEnd     = this.getAverage(scrollingsY, 10);
      averageMiddle  = this.getAverage(scrollingsY, 70);
      isAccelerating = averageEnd >= averageMiddle;
      isMac = true;
      if(isSafari){
        isMac = 1.3<(Math.abs(e.deltaY)/(e.timeStamp-timeStamp));
      }
      if(isAccelerating && isMac){
        canScrollY = false;
        setTimeout(()=>{canScrollY = true}, 700);
        this.setState({
          scrollY: e,
          scrollId: 1+this.state.scrollId
        })
      }    
      timeStamp = e.timeStamp;
    }
  }
  getAverage(elements, number){
    var sum = 0;
    var lastElements = elements.slice(Math.max(elements.length - number, 1));
    for(var i = 0; i < lastElements.length; i++){
        sum = sum + lastElements[i];
    }
    return Math.ceil(sum/number);
  }
  render(){
    return(
      <LangChangeEventContext.Provider value={{
        lang:               i18next,
        change:             this.changeLang,
        changeEn:           this.changeLangEn,
        changeRu:           this.changeLangRu
      }}>

       {/* <BrowserRouter>
          <Switch>
              <Route exact path='/'                     render={(props) =>(<Main     {...props} data ={this.props.main}/>)} />
              <Route exact path='/contacts'             render={(props) =>(<Contacts {...props} data ={this.props.contacts}/>)} />
              <Route exact path='/gallery'              render={(props) =>(<Gallery  {...props} data ={this.props.gallery}/>)} />
          </Switch>
        </BrowserRouter>  */}
      
      {/*
        const extraProps = { color: 'red' }
        <Route path='/page' render={(props) => (
          <Page {...props} data={extraProps}/>
        )}/>    
      */}

        <BrowserRouter>
          <Route
            render={({ location }) => (
              <TransitionGroup>
                <CSSTransition key={location.key} classNames="fade" timeout={{exit:500, enter:300}}>
                  <Switch location={location}>
                    <Route exact path='/'         
                      render={(props) =>(
                        <Main     
                          {...props} 
                          data      = {this.props.main}  
                          menu      = {this.props.menu}   
                          scrollY   = {this.state.scrollY} 
                          scrollId  = {this.state.scrollId}
                          ADMIN_URL = {this.props.ADMIN_URL}
                        />
                      )}
                        
                    />
                    <Route exact path='/contacts' 
                      render={(props) =>(
                        <Contacts 
                          {...props} 
                          data      = {this.props.contacts}   
                          menu      = {this.props.menu} 
                          scrollY   = {this.state.scrollY} 
                          scrollId  = {this.state.scrollId}
                          ADMIN_URL = {this.props.ADMIN_URL}
                        />
                      )}
                    />
                    <Route exact path='/gallery'  
                      render={(props) =>(
                        <Gallery  
                          {...props} 
                          data      = {this.props.gallery}    
                          menu      = {this.props.menu} 
                          scrollY   = {this.state.scrollY} 
                          scrollId  = {this.state.scrollId}
                          ADMIN_URL = {this.props.ADMIN_URL}
                        />
                      )} 
                    />
                  </Switch>
                </CSSTransition>
              </TransitionGroup>
            )}
          />
        </BrowserRouter>

      </LangChangeEventContext.Provider>
    )
  }
}    




// WEBPACK FOOTER //
// ./src/App.js